import { Button, Form, Input, InputNumber } from "antd";
import AddIcon from "../../assets/icons/AddIcon";
import DeleteIcon from "../../assets/icons/DeleteIcon";

type KPIAddMoreFormProps = {
  kpiArray: string;
  kpiType: string;
  weighage: string;
  details: string;
  disabled?: boolean;
};

export default function KPIAddMoreForm({
  kpiArray,
  kpiType,
  weighage,
  details,
  disabled,
}: KPIAddMoreFormProps) {
  return (
    <Form.List name={kpiArray} initialValue={[{}]}>
      {(fields, { add, remove }) => (
        <>
          {fields.map((field, index) => (
            <div key={field.key}>
              <div className="self-stretch px-3 py-1.5 bg-slate-100 rounded-md inline-flex justify-start items-center gap-2.5 w-full flex-wrap">
                <div className="flex justify-between items-center w-full gap-2.5">
                  <div className="text-slate-600 text-lg font-semibold">
                    KPI - {String(index + 1).padStart(2, "0")}
                  </div>

                  {!disabled && fields.length > 1 && (
                    <div
                      className="cursor-pointer"
                      onClick={() => remove(field.name)}
                    >
                      <DeleteIcon color="#F05323" />
                    </div>
                  )}
                </div>
              </div>

              <div className="md:flex justify-between items-end mt-4">
                <div className="md:flex items-center gap-3 md:w-[75%]">
                  <Form.Item
                    name={[field.name, kpiType]}
                    label="Type KPI"
                    className="md:w-1/2"
                    rules={[
                      {
                        required: true,
                        message: "Please enter title",
                      },
                    ]}
                  >
                    <Input
                      className="w-full"
                      size="large"
                      placeholder="Enter KPI title"
                      disabled={disabled}
                    />
                  </Form.Item>

                  <Form.Item
                    name={[field.name, weighage]}
                    label="Weighage (%)"
                    className="md:w-1/2"
                    validateFirst
                    rules={[
                      {
                        required: true,
                        message: "Please enter weighage",
                      },
                      {
                        validator: (_, value) => {
                          if (value === undefined || value === null)
                            return Promise.resolve();
                          if (value < 0)
                            return Promise.reject(
                              "Weighage cannot be negative"
                            );
                          if (value === 0)
                            return Promise.reject("Weighage cannot be zero");
                          if (value > 100)
                            return Promise.reject(
                              "Weighage cannot be greater than 100"
                            );
                          if (!/^\d+(\.\d{1,2})?$/.test(value.toString())) {
                            return Promise.reject(
                              "Weighage must not exceed 2 decimal places"
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <InputNumber
                      className="w-full"
                      size="large"
                      placeholder="%"
                      disabled={disabled}
                      stringMode
                    />
                  </Form.Item>
                </div>

                <div className="md:w-[25%]"></div>
              </div>

              <div className="md:flex justify-between items-end">
                <div className="md:flex items-center gap-3 md:w-[75%]">
                  <Form.Item
                    name={[field.name, details]}
                    label="Details"
                    className="w-full"
                    rules={[
                      {
                        required: true,
                        message: "Please enter KPI details",
                      },
                    ]}
                  >
                    <Input.TextArea
                      className="w-full"
                      size="large"
                      placeholder="Enter KPI details"
                      disabled={disabled}
                    />
                  </Form.Item>
                </div>

                {!disabled ? (
                  <div className="md:w-[25%] md:pl-3 mb-6 text-end md:text-start">
                    {index === fields.length - 1 && (
                      <Button
                        onClick={() => add()}
                        className="h-11 px-3.5 py-2 bg-white rounded-md outline outline-1 outline-offset-[-1px] outline-orange-600 inline-flex justify-center items-center gap-2.5 overflow-hidden"
                      >
                        <div className="flex justify-center items-center gap-2">
                          <AddIcon color="#F05323" />
                          <span className="text-orange-600 text-sm font-semibold leading-normal">
                            Add More
                          </span>
                        </div>
                      </Button>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        </>
      )}
    </Form.List>
  );
}
